export default __webpack_public_path__ + "static/media/wirecard.04902537.svg";